import React, { useEffect, useRef } from "react";
import { get_date } from "../generalComponets";
import { useReactToPrint } from "react-to-print";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Image, Heading } from "../elements";
import { CLRS } from "../../constants/colors";
import { PulseLoader } from "react-spinners";

export function AppReportTemplate2(
  {
    //     fields=[
    //       ],
    //     data = [
    // ],
    //     config = {
    //         title:"",
    //         title2:"",
    //         subTitle:"",
    //         dateFrom:"",
    //         dateTo:"",
    //       }
  },
) {
  const printRef = useRef<HTMLDivElement>(null);
  const location = useLocation();
  let fields = location.state.fields;
  let config = location.state.config;
  let data = location.state.data;

  useEffect(() => {
    setTimeout(() => {
      handlePrint();
    }, 1000);
  }, []);

  const navigate = useNavigate();
  const handlePrint = useReactToPrint({
    contentRef: printRef,
    onAfterPrint: () => {
      navigate(-1);
    },
  });

  return (
    <>
      <div>
        <div ref={printRef} style={styles.main}>
          <div style={styles.titleDiv}>
            <img
              src="https://firebasestorage.googleapis.com/v0/b/reducer-app.appspot.com/o/ic_launcher.png?alt=media&token=e6611ece-b5c7-4735-9ad8-84ef4656e5ee"
              style={styles.image}
            />
            <div style={{}}>
              <p style={{ fontSize: "22px", margin: 0 }}>{config.title} </p>
              <p style={styles.genText}>Generated On - {get_date()}</p>
            </div>
          </div>
          <div style={styles.title2dIv}>
            <p style={{ fontSize: 16 }}>{config.title2}</p>
            {config.dateFrom ? <p>Date Range: {"ASdas"}</p> : null}
          </div>
          <p style={{ fontSize: "14px", marginTop: "0" }}>{config.subTitle}</p>

          <div style={styles.headerDiv}>
            {fields.map((item) => {
              return <p style={styles.headerText}>{item.title}</p>;
            })}
          </div>
          {data.map((data, i) => {
            return (
              <div style={styles.bodyDiv}>
                {fields.map((item) => {
                  if (item.key === "slno") {
                    return <p style={styles.bodyText}> {data.tt ? "" : 1 + i}</p>;
                  } else if (item.key === "date") {
                    return <p style={styles.bodyText}>{get_date(data.date)}</p>;
                  } else {
                    return <p style={styles.bodyText}>{data[item.key]}</p>;
                  }
                })}
              </div>
            );
          })}
        </div>
        <div
          style={{
            position: "absolute",
            width: "100vw",
            top: 0,
            backgroundColor: "rgba(255,255,255,1)",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box className="mc-spinner">
            <Image src="images/CoWalletLogo.webp" aly="logo" />
            <Box className="mc-spinner-group">
              <Heading className="primeColor">Loading</Heading>
              <PulseLoader color={CLRS.MEAT_BLACK} loading={true} size={8} />
            </Box>
          </Box>
        </div>
      </div>
    </>
  );
}

const styles = {
  main: { padding: "16px 16px", backgroundColor: "white" },
  titleDiv: {
    backgroundColor: "#f1f5ff",
    padding: "16px",
    display: "flex",
    marginTop: "0px",
    alignItems: "center",
  },
  image: { width: "80px", height: "80px", marginRight: "16px" },
  genText: { margin: 0, marginTop: -10 },
  title2dIv: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 16,
  },
  headerDiv: {
    display: "flex",
    borderBottom: "#e5e5e5 1px solid",
    borderLeft: "#e5e5e5 1px solid",
    borderRight: "#e5e5e5 1px solid",
    borderTop: "#e5e5e5 1px solid",
    backgroundColor: "#f1f5ff",
    marginTop: "24px",
  },
  headerText: {
    color: "black",
    fontSize: "14px",
    fontWeight: "bold",
    margin: "0px",
    padding: "6px",
    textAlign: "left",
    flex: "1",
    WebkitFlex: "1",
    WebkitBoxFlex: "1",
  },
  bodyDiv: {
    display: "flex",
    borderLeft: "#e5e5e5 1px solid",
    borderRight: "#e5e5e5 1px solid",
    borderBottom: "#e5e5e5 1px solid",
  },
  bodyText: {
    fontSize: "14px",
    margin: "0px",
    padding: "6px",
    textAlign: "left",
    color: "#000000",
    WebkitFlex: "1",
    WebkitBoxFlex: "1",
    flex: "1",
  },
};
